// extracted by mini-css-extract-plugin
export default {"container":"BasicPageDocumentation_container__7-OsM","propertyDivider":"BasicPageDocumentation_propertyDivider__Rgnld","warning":"BasicPageDocumentation_warning__n0y6m"};